module.exports = function makeDropdownUsable(dropdown) {
  if (Object.prototype.toString.call(dropdown) === '[object String]') {
    dropdown = $(dropdown);
  }

  if(dropdown.find('> a').is('[data-toggle="dropdown"], .dropdowned')) {
    return dropdown;
  }

  dropdown.addClass('dropdowned');

  dropdown.on('click', function(e) {
    dropdown.toggleClass('open');
  });

  nifty.body.on('click', function(e) {
    if (!$(e.target).is('.head-list *, #dropdown-user, #dropdown-user > a, #dropdown-user > a > *')) {
      dropdown.removeClass('open');
    }
  });

  return dropdown;
};
